// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import {DoubleSide,FrontSide,MeshStandardMaterial} from 'three'
import optics from '../../SourceArt/AcrylicSurfaces/finish.json'
import type {FinishNumbers} from './partsKit'

/** Thin polished polymer: preserve background attenuation, reflect the venue above it. */
export function acrylicSurface(name:string,finish:FinishNumbers):MeshStandardMaterial {
 const response=name==='rampClearEdge'?{...optics,...optics.cutEdge}:optics
 const made=new MeshStandardMaterial({name:'acrylic.'+name,color:finish.color,roughness:response.roughness,
  metalness:0,opacity:finish.opacity??1,transparent:true,depthWrite:false,
  side:finish.doubleSided?DoubleSide:FrontSide,envMapIntensity:response.reflectionStrength})
 made.onBeforeCompile=shader=>{
  shader.fragmentShader=shader.fragmentShader.replace('#include <lights_physical_fragment>',
   '#include <lights_physical_fragment>\nmaterial.specularColor=vec3('+optics.fresnel0+');')
  shader.fragmentShader=shader.fragmentShader.replace('#include <opaque_fragment>',`
vec3 acrylicDiffuse=(reflectedLight.directDiffuse+reflectedLight.indirectDiffuse)*${response.diffuseScatter};
vec3 acrylicSpecular=min(reflectedLight.directSpecular+reflectedLight.indirectSpecular,vec3(${response.maxReflectance}));
outgoingLight=acrylicDiffuse+acrylicSpecular/max(diffuseColor.a,.001);
#include <opaque_fragment>`)
 }
 made.customProgramCacheKey=()=> 'playfield-acrylic02.'+(name==='rampClearEdge'?'edge':'sheet')
 return made
}
